import {useCallback, useMemo, useReducer} from 'react';

const RECT_PROPERTIES = ['top', 'left', 'right', 'bottom', 'width', 'height'];

function isRectEqual(r1, r2) {
    if (r1 === r2) return true;
    for (let prop of RECT_PROPERTIES) {
        if (r1?.[prop] != r2?.[prop]) return false;
    }
    return true;
}

export const useElementRect = ref => {
    const rect = ref.current?.getBoundingClientRect();
    return useMemo(
        () => rect,
        RECT_PROPERTIES.map(prop => rect?.[prop])
    );
};

function updateRegionReducer(regions, action) {
    switch (action.type) {
        case 'reserve':
            if (!isRectEqual(regions[action.id], action.rect)) {
                regions = {
                    ...regions,
                    [action.id]: action.rect,
                };
            }
            break;
        case 'free':
            if (regions[action.id]) {
                regions = {...regions};
                delete regions[action.id];
            }
            break;
    }
    return regions;
}

export const useProtectedRegions = props => {
    const {containerRef} = props,
        containerRect = useElementRect(containerRef), 
        [regions, updateRegion] = useReducer(updateRegionReducer, {}),
        relativeRegions = useMemo(() => {
            if (!containerRect) return [];

            return Object.values(regions).map(r => {
                let top = r.top - containerRect.top,
                    left = r.left - containerRect.left,
                    right = r.right - containerRect.left,
                    bottom = r.bottom - containerRect.top,
                    width = r.width,
                    height = r.height;
                return {top, left, right, bottom, width, height};
            });
        }, [containerRect, regions]);

    const handleUpdateRegion = useCallback((id, rect) => {
        if (rect) {
            updateRegion({type: 'reserve', id, rect});
        } else {
            updateRegion({type: 'free', id, rect});
        }
    }, []);

    return [relativeRegions, handleUpdateRegion];
};
